import * as z from 'zod';

import { CompanyId, SftpKeyId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';

export const SftpKeyOrigin = z.enum(['WILLOW_GENERATED', 'CUSTOMER_PROVIDED']);
export type SftpKeyOrigin = z.infer<typeof SftpKeyOrigin>;

export const SftpKeyAlgorithm = z.enum([
  'ED25519',
  'RSA_2048',
  'RSA_3072',
  'RSA_4096',
  'ECDSA_P256',
  'ECDSA_P384',
  'ECDSA_P521',
]);
export type SftpKeyAlgorithm = z.infer<typeof SftpKeyAlgorithm>;

// Actor info for key creation lives in the audit log entry, not on the row.
export const SftpKey = z.object({
  id: SftpKeyId,
  companyId: CompanyId,
  name: z.string(),
  origin: SftpKeyOrigin,
  algorithm: SftpKeyAlgorithm,
  publicKey: z.string(),
  // Canonical OpenSSH form: `SHA256:<base64-no-padding>`.
  fingerprint: z.string(),
  createdAt: zodDateOrString,
});
export type SftpKey = z.infer<typeof SftpKey>;
